module.exports = __webpack_public_path__ + "img/otima.5a78f772.svg";